import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { User_Data_Key, getData, saveData } from "../../utils/localStorageManager";
import "./LogoutButtonV7.scss";

const LogoutButtonV7 = ({ className, showIcon = true, showText = true }) => {
  const { t: trans, i18n } = useTranslation(["common", "user", "navbar", "info"]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [userName, setUserName] = useState("");
  const lang = i18n.language || "ar";

  useEffect(() => {
    try {
      const data = getData(User_Data_Key, true);
      if (data) {
        const _temp = JSON.parse(data);
        const langKey = lang === "ar" ? "Ar" : "En";
        const firstName = _temp[`FirstName${langKey}`] || _temp[`${lang}FirstName`];
        const lastName = _temp[`LastName${langKey}`] || _temp[`${lang}LastName`];
        if (firstName) {
          setUserName(firstName + " " + (lastName || ""));
        } else {
          setUserName(trans("info:profile"));
        }
      }
    } catch (error) {
      console.log("Error fetching user data:", error);
    }
  }, [lang, trans]);

  const deleteAllCookies = () => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + "=;max-age=-1";
    }
  };

  const handleLogout = () => {
    window.localStorage.clear();
    saveData("i18nextLng", lang, false);
    deleteAllCookies();
    window.location = "/";
  };

  const LogoutModal = () => {
    return createPortal(
      <div className="logout-v7-modal-overlay" onClick={() => setShowConfirm(false)}>
        <div className="logout-v7-modal" onClick={(e) => e.stopPropagation()}>
          <div className="logout-v7-modal-header">
            <div className="logout-v7-icon-circle">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </div>
          </div>
          <div className="logout-v7-modal-body">
            <h3>{lang === 'ar' ? `عزيزي ${userName}` : `Dear ${userName}`}</h3>
            <p>{lang === 'ar' ? 'هل أنت متأكد من أنك تريد تسجيل الخروج؟' : 'Are you sure you want to log out?'}</p>
          </div>
          <div className="logout-v7-modal-footer">
            <button className="v7-logout-confirm-btn" onClick={handleLogout}>
              {lang === 'ar' ? 'نعم، تسجيل الخروج' : 'Yes, Log Out'}
            </button>
            <button className="v7-logout-cancel-btn" onClick={() => setShowConfirm(false)}>
              {lang === 'ar' ? 'لا، البقاء' : 'No, Stay'}
            </button>
          </div>
          <button className="logout-v7-close-x" onClick={() => setShowConfirm(false)}>✕</button>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <>
      <button
        className={`v7-logout-btn-comp ${className || ""}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowConfirm(true);
        }}
      >
        <div className="v7-logout-btn-content">
          {showIcon && (
            <img
              src="/assets/user_profile/icons/logout.svg"
              alt="logout"
              className="logout-icon"
            />
          )}
          {showText && (
            <span className="logout-text">{trans("user:logout")}</span>
          )}
        </div>
      </button>

      {showConfirm && <LogoutModal />}
    </>
  );
};

export default LogoutButtonV7;
